export default __webpack_public_path__ + "static/media/HTTPS-ICON.057b7818.png";